// components/Navbar.js
import React from 'react';

const Navbar = () => {
  return (
    <div style={{ backgroundColor: '#333', color: '#fff', padding: '10px', textAlign: 'center' }}>
      <h1>Admin Dashboard</h1>
    </div>
  );
};

export default Navbar;
